(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  if (!menuButton) return;

  const menuId = menuButton.getAttribute('aria-controls');
  if (!menuId) return;

  const menu = document.getElementById(menuId);
  if (!menu) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const closeMenu = () => {
    menuButton.setAttribute('aria-expanded', 'false');
    menu.hidden = mobileQuery.matches;
  };

  const syncMenuForViewport = () => {
    if (mobileQuery.matches) {
      menu.hidden = menuButton.getAttribute('aria-expanded') !== 'true';
      return;
    }

    menuButton.setAttribute('aria-expanded', 'false');
    menu.hidden = false;
  };

  syncMenuForViewport();

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncMenuForViewport);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncMenuForViewport);
  }

  menuButton.addEventListener('click', () => {
    const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!isOpen));
    menu.hidden = isOpen;
  });

  menu.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
      closeMenu();
      menuButton.focus();
    }
  });
})();

(() => {
  const options = Array.from(document.querySelectorAll('[data-product-variant-option]'));
  if (!options.length) return;

  const fieldset = options[0].closest('[data-product-section]');
  const sectionId = fieldset ? fieldset.getAttribute('data-product-section') : null;
  const variantId = document.querySelector('[data-product-variant-id]');
  const price = document.querySelector(`[data-product-price][data-product-section="${sectionId}"]`);
  const comparePrice = document.querySelector(`[data-product-compare-price][data-product-section="${sectionId}"]`);
  const form = variantId ? variantId.form : null;
  const submit = form ? form.querySelector('[data-product-submit]') : null;
  if (!variantId || !form || !submit) return;

  variantId.name = 'id';

  const updateVariant = () => {
    const checked = options.find((option) => option.checked);
    if (!checked) return;

    const available = checked.dataset.available === 'true';
    variantId.value = checked.value;
    if (price) price.textContent = checked.dataset.price || '';
    if (comparePrice) {
      comparePrice.textContent = checked.dataset.comparePrice || '';
      comparePrice.hidden = !checked.dataset.comparePrice;
    }
    submit.disabled = !available;
    submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
  };

  options.forEach((option) => option.addEventListener('change', updateVariant));
  updateVariant();
})();

(() => {
  document.querySelectorAll('[data-quantity-stepper]').forEach((stepper) => {
    const input = stepper.querySelector('[data-quantity-input]');
    if (!input) return;

    const min = parseInt(input.getAttribute('min'), 10) || 1;

    stepper.querySelectorAll('[data-quantity-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = parseInt(button.getAttribute('data-quantity-step'), 10) || 0;
        const current = parseInt(input.value, 10) || min;
        input.value = Math.max(min, current + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Typing straight into the field can leave it empty or below the minimum.
    input.addEventListener('blur', () => {
      const value = parseInt(input.value, 10);
      input.value = Number.isNaN(value) ? min : Math.max(min, value);
    });
  });
})();

(() => {
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  const items = Array.from(gallery.querySelectorAll('[data-gallery-item]'));
  if (!items.length) return;

  const activate = (mediaId) => {
    if (!mediaId) return false;
    const matched = items.some((item) => item.dataset.mediaId === mediaId);
    if (!matched) return false;

    items.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === mediaId));
    thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId));
    return true;
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => activate(thumb.dataset.mediaId));
  });

  const options = Array.from(document.querySelectorAll('[data-product-variant-option]'));
  if (!options.length) return;

  const syncToVariant = () => {
    const checked = options.find((option) => option.checked);
    if (checked && checked.dataset.mediaId) activate(checked.dataset.mediaId);
  };

  options.forEach((option) => option.addEventListener('change', syncToVariant));
  syncToVariant();
})();
